import React from 'react';
import { Inbox } from 'lucide-react';

// Empty state cohérent réutilisable (voir index.css .empty-state).
export default function EmptyState({ title, description, action, icon: Icon = Inbox }) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon"><Icon size={23} aria-hidden="true" /></span>
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
